import { render, staticRenderFns } from "./AssayList.vue?vue&type=template&id=711b0790"
import script from "./AssayList.vue?vue&type=script&lang=js"
export * from "./AssayList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports